import React from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from '../i18n/TranslationContext';

export function ContractUCMProcessing() {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] mb-6">
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 bg-[var(--ucm-light-blue)] rounded-full flex items-center justify-center mr-3">
          <Clock size={16} className="text-[var(--ucm-dark-blue)]" />
        </div>
        <h3 className="font-semibold text-[var(--ucm-text-dark)]">{t('contractStatus.contractProcess')}</h3>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-[var(--ucm-text-medium)]">{t('contractStatus.status')}</span>
          <span className="text-sm font-semibold text-[var(--ucm-info-blue)]">{t('contractStatus.ucmProcessing.status')}</span>
        </div>
        <p className="text-sm text-[var(--ucm-text-medium)] mb-3">
          {t('contractStatus.ucmProcessing.description')}
        </p>
        
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--ucm-primary-teal)]"></div>
        </div>
        
        <p className="text-xs text-[var(--ucm-text-light)] text-center mb-4">
          {t('contractStatus.ucmProcessing.waiting')}
        </p>
        
        <div className="text-xs text-[var(--ucm-text-light)] mb-4">
          {t('contractStatus.stepOf', { current: 5, total: 8 })}
        </div>
      </div>

      <div className="bg-[var(--ucm-disabled-gray)] rounded-full h-12 flex items-center justify-center">
        <span className="text-[var(--ucm-text-medium)] font-semibold">{t('contractStatus.ucmProcessing.waitingForUCM')}</span>
      </div>
    </div>
  );
}